__turbopack_context__.v({
  "attributes": "Details-module__VaovEa__attributes",
  "containerBody": "Details-module__VaovEa__containerBody",
  "key": "Details-module__VaovEa__key",
  "linkValue": "Details-module__VaovEa__linkValue",
  "root": "Details-module__VaovEa__root",
  "row": "Details-module__VaovEa__row",
  "title": "Details-module__VaovEa__title",
  "value": "Details-module__VaovEa__value",
  "valueSkele": "Details-module__VaovEa__valueSkele",
});
